<template>
  <nav
    class="relative pb-8 transition-all duration-250 ease-in-out mt-5 md:mt-0 md:px-10 md:pb-0 mx-auto"
  >
    <ul
      class="flex h-full flex-col grow-0 gap-4 py-4 text-lg md:flex-row md:gap-2 md:pt-0 md:text-md md:font-bold bg-white rounded-xl md:bg-transparent w-fit ml-auto"
    >
      <li
        v-for="(link, i) in serviceMenuLinks"
        :key="`global_${i}`"
        class="flex items-center px-4 md:px-0 md:mt-4"
      >
        <VuepalLink
          :to="link.href"
          class="flex md:h-[50px] w-full items-center justify-end px-4 pl-2 transition-all page-landing:text-black md:page-landing:text-white md:page-landing:hover:text-yellow hover:text-violet duration-250 ease-in-out md:size-auto md:px-0 md:pl-2 before:content-[''] before:size-3 before:rounded-full md:page-landing:before:bg-petrol before:bg-white before:mr-2 before:-mt-0.5"
          :active-class="'md:pl-7 before:!bg-darkGreen !text-darkGreen page-landing:md:before:!bg-lightGreen page-landing:md:!text-lightGreen'"
        >
          {{ link.label }}
        </VuepalLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const { serviceMenuLinks } = useInitData()
</script>
